// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__266be","additionalInfo":"AgreementModal_additionalInfo__2isfx"};